import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { Header } from '../components/headers/header';
import { Col, FlexboxGrid } from 'rsuite';
import { Sidebar } from '../components/sidebar/sidebar';
import { ConsultantPersonal } from '../pages/consultants/consultant-personal';
import { ConsultantWorkBackground } from '../pages/consultants/consultant-work-background';
import { ConsultantEducationBackground } from '../pages/consultants/consultant-education-background';
import { ConsultantConsultationBackground } from '../pages/consultants/consultant-consultation-background';
import { ConsultantSocial } from '../pages/consultants/consultant-social';
import { Auth } from '../pages/auth/auth';
import { ChooseRole } from '../pages/choose-role/choose-role';
import { ConsultantTnC } from '../pages/consultants/consultant-tnc';
import { ConsultantMeetingReport } from '../pages/consult/consultant-meeting-report';
import { ConsulteeMeetingReport } from '../pages/consult/consultee-meeting-report';
// import { AdminRegisterConsultant } from '../pages/admin/consultants/register-consultatn';
import { AdminRegisterConsultantList } from '../pages/admin/consultants/consultants-register-list';
import { AdminRegisterConsultantSingle } from '../pages/admin/consultants/consultants-register-single';
import { ConsultantsList } from '../pages/public/consultants/consultants-list';
import { SingleConsultant } from '../pages/public/consultants/single-consultant';
import { Logout } from './../pages/auth/logout';
import { ConsultRequests } from '../pages/consult/consult-requests';
import { SetConsultSession } from '../pages/consult/set-consult-session';
import { AuthGuard } from './guards/_auth-guard';
import { AdminAuthGuard } from './guards/_admin-guard copy';

interface Props {
  name: string;
}

const Dummy = ({ name }: Props) => <p className="text-center">{name}</p>;
const CustomNavigator = ({ to }: { to: string }) => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(to);
  }, []);
  return <></>;
};

// const PAGES = {
//   feed: {
//     title: 'خانه',
//     lastPage: null
//   },
//   singleFeed: {
//     title: 'جزئیات پست',
//     lastPage: '/'
//   },
//   examination: {
//     title: 'بخش معاینه',
//     lastPage: '/'
//   },
//   expertise: {
//     title: 'رزرو نوبت ویزیت',
//     lastPage: '/'
//   },
//   expertiseList: {
//     title: 'دریافت نوبت از پزشکان',
//     lastPage: '/'
//   },
//   signUp: {
//     title: 'MedMe',
//     lastPage: '/'
//   },
//   login: {
//     title: 'MedMe',
//     lastPage: '/'
//   },
//   temp: {
//     title: '',
//     lastPage: null
//   },
//   fof: {
//     title: 'یافت نشد',
//     lastPage: null
//   }
// };

interface EmptyLayoutProps {
  children: React.ReactNode;
}
const EmptyLayout = (props: EmptyLayoutProps) => (
  <>
    <Header />
    <FlexboxGrid className="w-full mt-12 mb-5">
      <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={24}>
        {props.children}
      </FlexboxGrid.Item>
    </FlexboxGrid>
  </>
);
interface LayoutProps {
  children: React.ReactNode;
  sidebar: {
    page: string;
    step: number;
  };
}
const FullLayout = (props: LayoutProps) => (
  <>
    <Header />
    <FlexboxGrid className="w-full mt-12 mb-5">
      <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={24}>
        <div className="bg-[--rs-white] p-8 rounded-md border-[1px] border-[--rs-primary-300] ml-2 mr-2 md:mr-16 md:ml-16">
          {props.children}
        </div>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  </>
);
const Layout = (props: LayoutProps) => (
  <>
    <Header />
    <FlexboxGrid className="w-full mt-12 mb-5">
      <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={6}>
        <Sidebar page={props.sidebar.page} step={props.sidebar.step} />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={18}>
        <div className="bg-[--rs-white] p-8 rounded-md border-[1px] border-[--rs-primary-300] ml-2 mr-2 md:mr-6 md:ml-16">
          {props.children}
        </div>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  </>
);
const LayoutWithoutBox = (props: LayoutProps) => (
  <>
    <Header />
    <FlexboxGrid className="w-full mt-12 mb-5">
      <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={6}>
        <Sidebar page={props.sidebar.page} step={props.sidebar.step} />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={18}>
        <div className="ml-2 mr-2 md:mr-6 md:ml-16">{props.children}</div>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  </>
);

export const routes = (_isPing: boolean) => [
  {
    path: '/',
    element: (
      <AuthGuard>
        <CustomNavigator to="/choose-role" />
      </AuthGuard>
    )
  },

  {
    path: '/consultant/personal',
    element: (
      <AuthGuard>
        <Layout sidebar={{ page: 'consultant', step: 1 }}>
          <ConsultantPersonal />
        </Layout>
      </AuthGuard>
    )
  },
  {
    path: '/consultant/work',
    element: (
      <AuthGuard>
        <Layout sidebar={{ page: 'consultant', step: 2 }}>
          <ConsultantWorkBackground />
        </Layout>
      </AuthGuard>
    )
  },
  {
    path: '/consultant/education',
    element: (
      <AuthGuard>
        <Layout sidebar={{ page: 'consultant', step: 3 }}>
          <ConsultantEducationBackground />
        </Layout>
      </AuthGuard>
    )
  },
  {
    path: '/consultant/consultation',
    element: (
      <AuthGuard>
        <Layout sidebar={{ page: 'consultant', step: 4 }}>
          <ConsultantConsultationBackground />
        </Layout>
      </AuthGuard>
    )
  },
  {
    path: '/consultant/social',
    element: (
      <AuthGuard>
        <Layout sidebar={{ page: 'consultant', step: 5 }}>
          <ConsultantSocial />
        </Layout>
      </AuthGuard>
    )
  },
  {
    path: '/consultant/tnc',
    element: (
      <AuthGuard>
        <Layout sidebar={{ page: 'consultant', step: 6 }}>
          <ConsultantTnC />
        </Layout>
      </AuthGuard>
    )
  },
  {
    path: '/consultant/requests',
    element: (
      <AuthGuard>
        <FullLayout sidebar={{ page: 'default', step: 1 }}>
          <ConsultRequests />
        </FullLayout>
      </AuthGuard>
    )
  },
  {
    path: '/user/requests',
    element: (
      <AuthGuard>
        <FullLayout sidebar={{ page: 'default', step: 1 }}>
          <ConsultRequests />
        </FullLayout>
      </AuthGuard>
    )
  },
  {
    path: '/consultant/meeting-report/:id',
    element: (
      <AuthGuard>
        <Layout sidebar={{ page: 'consultant', step: 6 }}>
          <ConsultantMeetingReport />
        </Layout>
      </AuthGuard>
    )
  },
  {
    path: '/user/meeting-report/:id',
    element: (
      <AuthGuard>
        <Layout sidebar={{ page: 'default', step: 1 }}>
          <ConsulteeMeetingReport />
        </Layout>
      </AuthGuard>
    )
  },
  // {
  //   path: '/user/meeting-reports',
  //   element: (
  //     <Layout sidebar={{ page: 'default', step: 1 }}>
  //       <MeetingReports />
  //     </Layout>
  //   )
  // },
  {
    path: '/user/consult-sessions/:id',
    element: (
      <AuthGuard>
        <FullLayout sidebar={{ page: 'default', step: 1 }}>
          <SetConsultSession asConsultant={false} />
        </FullLayout>
      </AuthGuard>
    )
  },
  {
    path: '/consultant/consult-sessions/:id',
    element: (
      <AuthGuard>
        <FullLayout sidebar={{ page: 'default', step: 1 }}>
          <SetConsultSession asConsultant={true} />
        </FullLayout>
      </AuthGuard>
    )
  },

  // Admin
  // {
  //   path: '/admin/register-consultant',
  //   element: (
  //     <Layout sidebar={{ page: 'default', step: 1 }}>
  //       <AdminRegisterConsultant />
  //     </Layout>
  //   )
  // },

  {
    path: '/admin/register-consultant-list',
    element: (
      <AdminAuthGuard>
        <Layout sidebar={{ page: 'admin', step: 1 }}>
          <AdminRegisterConsultantList />
        </Layout>
      </AdminAuthGuard>
    )
  },
  {
    path: '/admin/register-consultant-single/:username',
    element: (
      <AdminAuthGuard>
        <Layout sidebar={{ page: 'default', step: 1 }}>
          <AdminRegisterConsultantSingle />
        </Layout>
      </AdminAuthGuard>
    )
  },
  {
    path: '/auth/admin',
    element: <Auth isAdminMode={true} />
  },
  {
    path: '/auth/login',
    element: <Auth isAdminMode={false} />
  },
  {
    path: '/logout',
    element: <Logout />
  },
  {
    path: '/choose-role',
    element: (
      <AuthGuard>
        <FullLayout sidebar={{ page: 'chooseRole', step: 1 }}>
          <ChooseRole />
        </FullLayout>
      </AuthGuard>
    )
  },
  // public
  {
    path: '/consultants',
    element: (
      <AuthGuard>
        <LayoutWithoutBox sidebar={{ page: 'default', step: 1 }}>
          <ConsultantsList />
        </LayoutWithoutBox>
      </AuthGuard>
    )
  },
  {
    path: '/consultants/:username',
    element: (
      <AuthGuard>
        <LayoutWithoutBox sidebar={{ page: 'default', step: 1 }}>
          <SingleConsultant />
        </LayoutWithoutBox>
      </AuthGuard>
    )
  },

  {
    path: '*',
    element: (
      <EmptyLayout>
        <Dummy name="404" />
      </EmptyLayout>
    )
  }
];
